// extracted by mini-css-extract-plugin
export default {"titleWrapper":"BoardModal_titleWrapper__WCL3R","elementModal":"BoardModal_elementModal__Its4a","form":"BoardModal_form__5dw+8"};